<template>
  <Breadcrumbs
      title="Review Trust"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Trust Management', path: '/trust-management' },
      { label: 'Review Trust', path: '/review-trust' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <reviewTrustForm/>
    </div>
  </div>
</template>

<script>

import reviewTrustForm from "@/pages/master_data/trust_management/reviewTrustForm.vue";

export default {
  components: {
    reviewTrustForm
  }
}

</script>